import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import MobileCartImage from 'app/components/MobileCartImage';

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;
const threshold = windowHeight * 3;// * 3;
const fontSize = parseInt(window.getComputedStyle(document.body).fontSize);
const isMobile = windowWidth < 960;
const containerWidth = isMobile ? windowWidth - 40 : windowWidth - windowWidth / 5 - 20;

const styles = theme => ({
  container: {
    float: 'left',
    width: '100%',
    marginBottom: '5em',
  },
  column: {
    float: 'left'
  },
  image: {
    float: 'left'
  },
  placeholder: {
    width: '100%',
    height: '100%',
    background: '#fff'
  }
});


class MobileCartGallery extends React.Component {
  constructor(props) {
    super(props);

    this.colHeights = {};
    this.visibleMoments = {};

    this.scrollListener = e => this.onScroll(e);

    this.showListener = e => this.processScrollPos();

    this.state = {
      photos: []
    }
  }

  componentDidMount() {
    if (!this.props.disableScrollListener) {
      let scrollNode = this.props.scrollNode && this.props.scrollNode.current;
      if (scrollNode) {
        scrollNode.addEventListener('scroll', this.scrollListener);
      } else {
        document.scrollingElement.addEventListener('scroll', this.scrollListener);
      }

      this.scrollApplied = true;

      document.body.addEventListener('show-moments', this.showListener);
    }

    this.setupPhotos();
  }

  componentWillUnmount() {
    if (!this.props.disableScrollListener) {
      const scrollNode = this.props.scrollNode && this.props.scrollNode.current;

      if (scrollNode) {
        scrollNode.removeEventListener('scroll', this.scrollListener);
      } else {
        document.scrollingElement.removeEventListener('scroll', this.scrollListener);
      }

      this.scrollApplied = false;

      document.body.removeEventListener('show-moments', this.showListener);
    }
  }

  shouldComponentUpdate(newProps, newState) {
    return this.props.moments.length !== newProps.moments.length ||
      this.state.photos.length !== newState.photos.length ||
      this.props.orientation !== newProps.orientation;
  }

  componentDidUpdate() {
    const { photos } = this.state;

    if (!photos.length || photos.length !== this.props.moments.length) {
      this.setupPhotos();
    }
  }

  onScroll() {
    this.processScrollPos();
  }

  processScrollPos() {
    const scrollNode = (this.props.scrollNode && this.props.scrollNode.current) || document.scrollingElement;
    if (!scrollNode) {
      return;
    }

    const scrollPos = scrollNode.scrollTop;

    const { galleryImages } = window;

    if (!galleryImages) {
      return;
    }

    // show or hide moments within or out of view
    for (let colIndex in this.colHeights) {
      for (let momentId in this.colHeights[colIndex].byImage) {
        let img = galleryImages[momentId];

        if (img) {
          let height = this.colHeights[colIndex].byImage[momentId];
          let inView = height < scrollPos + threshold && height > scrollPos - threshold;

          if (inView && !img.state.rendered) {
            img.setState({ rendered: true });

          } else if (!inView && img.state.rendered) {
            img.setState({ rendered: false, visible: false });
          }
        }
      }
    }
  }

  setupPhotos() {
    const { moments } = this.props;

    let photos = [];

    for (let i = 0, l = moments.length; i < l; i++) {
      let m = moments[i];

      // no video support for now
      // if (m.type && m.type.match(/video/)) {
      //   continue
      // }

      // newly created moments will have a data URI in preview_url
      photos.push({
        id: m.id,
        src: m.preview_url,
        thumb_url: m.thumb_url,
        thumb_url_large: m.thumb_url_large,
        preview_url_small: m.preview_url_small,
        preview_url: m.preview_url,
        print_url: m.print_url,
        width: m.width,
        height: m.height,
        index: m.position,
        moment_id: m.id,
        type: m.type,
        position: m.position
      });
    }

    this.setState({ photos });
  }

  render() {
    const {
      classes,
      index,
      columns, // column count
      resolution,
      maxResolution,
      initVisible,
      forceVisible,
      disableSort
    } = this.props;

    const { photos } = this.state;
    const width = this.props.containerWidth || containerWidth;

    let cols = [];
    let colWidth = parseInt(width / columns);
    this.colHeights = {};

    for (let i = 0; i < columns; i++) {
      cols.push([]);
      this.colHeights[i] = {
        total: fontSize * 4, // begin with 4rem for date header
        byImage: {}
      }
    }

    let sortedPhotos;
    if (disableSort) {
      sortedPhotos = photos || [];
    } else {
      sortedPhotos = photos ? [...photos].sort((a, b) => a.position < b.position ? -1 : 1) : [];
    }

    for (let i = 0, l = sortedPhotos.length; i < l; i++) {
      let photo = sortedPhotos[i];

      if (!photo.width || !photo.height) {
        continue;
      }

      photo.relative_width = colWidth;
      photo.relative_height = colWidth / photo.width * photo.height;

      let colIndex = cols.slice()
        .map((col, i) => i)
        .sort((a, b) => this.colHeights[a].total < this.colHeights[b].total ? -1 : 1)[0];

      cols[colIndex].push(photo);
      this.colHeights[colIndex].total += photo.relative_height;
      this.colHeights[colIndex].byImage[photo.moment_id] = this.colHeights[colIndex].total;
    }

    // store gallery height so that other galleries can compute their starting height
    let tallestIndex = Object.keys(this.colHeights)
      .sort((a, b) => this.colHeights[a].total < this.colHeights[b].total ? 1 : -1)[0];

    // hotfix for Kiosk component
    if (window.galleryHeights) {
      window.galleryHeights[index] = this.colHeights[tallestIndex].total;
    }

    let colsJsx = cols.map((col, colIndex) => {
      let images = col.map((photo, i) => {
        let style = {
          width: photo.relative_width + 'px',
          height: photo.relative_height + 'px'
        }

        let attrs = {
          photo: photo,
          top: parseInt(this.colHeights[colIndex].byImage[photo.moment_id] - photo.relative_height)
        }

        return (
          <div className={classes.image} style={style} key={photo.moment_id}>
            <MobileCartImage channel={`moment-${photo.moment_id}`}
              visible={forceVisible || (initVisible && i < 6)}
              resolution={resolution}
              maxResolution={maxResolution}
              progressive={true}
              attrs={attrs}
              scrollNode={this.props.scrollNode}
              style={this.props.galleryImageStyle}
              storyId={this.props.storyId}
              trackerOpts={this.props.trackerOpts}
              onToggleSelectMoment={this.props.onToggleSelectMoment}
              isMobile={isMobile}
            />
          </div>
        )
      });

      return (
        <div className={classes.column} style={{ width: colWidth + 'px' }} key={colIndex}>
          {images}
        </div>
      );
    });

    return (
      <div className={classes.container} style={{ width: width + 'px' }}>
        {colsJsx}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orientation: state.screenReducer && state.screenReducer.orientation
});

export default connect(mapStateToProps, {})(withStyles(styles, { withTheme: true })(MobileCartGallery));
